<template>
  <PropertyNotFound v-if="isMissing" />
  <RouterView v-else />
</template>

<script setup lang="ts">
import { computed, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';

import { useAvailabilityStore } from '@tallo/investor/availability';
import { PropertyOnboardingType } from '@tallo/investor/navigation';
import { PropertyNotFound, usePropertyStore } from '@tallo/investor/property';

const propertyStore = usePropertyStore();
const availabilityStore = useAvailabilityStore();
const route = useRoute();
const propertyId = route.params.propertyId;
const isMissing = computed(() => propertyStore.isMissing(route.params.propertyId as string));

if (propertyId.toString() !== PropertyOnboardingType.NewProperty) {
  propertyStore.loadProperty(propertyId.toString());
}

onUnmounted(() => {
  propertyStore.$reset();
  availabilityStore.$reset();
});
</script>

<style scoped lang="scss"></style>
